import React from 'react';
import Border from '../common/border';
import ActivityTitle from '../common/ActivityTitle';
import Icon from './Icon';
import { RoomOption } from '@/types/stayExperienceCardTypes';

interface WildPlanetStayProps {
  stay: RoomOption[];
}
const WildPlanetStay: React.FC<WildPlanetStayProps> = ({ stay }) => {
  console.log('room', stay);
  if (!stay || stay.length === 0) {
    return null; // Don't render if there's no data
  }

  return (
    <div className='mt-8'>
      <ActivityTitle title='Accommodation' className='' />
      <div className='grid xl:grid-cols-4 lg:grid-cols-3 xs:grid-cols-2 grid-cols-2 gap-4 mb-8 pt-2 max-w-2xl'>
        {stay.map((detail, index) => {
          const images = Array.isArray(detail.media)
            ? detail.media
                .filter(item => item.format === 'image')
                .map(item => item.url)
            : [];

          const locationData = detail.location
            ? {
                name: detail.location.name,
                city: detail.location.city,
                state: detail.location.state,
              }
            : undefined;

          console.log(`WildPlanetStay[${index}] location data:`, locationData);

          return (
            <Icon
              key={index}
              label={detail.name}
              images={images}
              description={detail.description}
              price={detail.payAtSiteCost}
              currency={detail.currency}
              currencySymbol={detail.currencySymbol}
              location={locationData}
              enableFullscreen={false}
            />
          );
        })}
      </div>
      <Border />
    </div>
  );
};

export default WildPlanetStay;
